import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
export function StandardDialog(props) {
    const { isOpen, setIsOpen, title, content, actions, children, maxWidth } = props;
    return (_jsxs(Dialog, { open: isOpen, onClose: () => setIsOpen(false), maxWidth: maxWidth, children: [title && _jsx(DialogTitle, { children: title }), content && _jsx(DialogContent, { children: content }), actions && _jsx(DialogActions, { children: actions }), children] }));
}
//# sourceMappingURL=StandardDialog.js.map